<script type="text/ecmascript-6">
    import TileQuestion from "../mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Hardware Cylinder';
                }
            },
            component_id: {
                default(){
                    return 'hardware_cylinder';
                }
            },
            slab: {
                required: true
            },
            hardwareHandle: {
                required: true
            },
            hardwareLock: {
                required: true
            },
            hardwareColour: {
                required: true
            },
            opening_direction: {
                required: true
            },
            securedByDesign: {
                default(){
                    return '1';
                }
            },
            doorRange: {
                required: true
            },
            collection: {
                default(){
                    return '';
                }
            },
            hardwareHandleInternal: {
              required: false,
              default(){
                return 0;
              }
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.hardwareHandle, this.hardwareLock, this.hardwareColour, this.securedByDesign, this.slab, this.opening_direction, this.doorRange, this.collection, this.hardwareHandleInternal);
            },
            url(){
                return '/api/options/' + this.fabricator + '/hardware-cylinder?slab=' + this.slab
                    + '&hardware_colour=' + this.hardwareColour
                    + '&hardware_handle=' + this.hardwareHandle
                    + '&hardware_lock=' + this.hardwareLock
                    + '&secured_by_design=' + this.securedByDesign
                    + '&opening_direction=' + this.opening_direction
                    + '&door_range=' + this.doorRange
                    + '&collection=' + this.collection
                    + '&hardware_handle_internal=' + this.hardwareHandleInternal;
            },
            cache_key(){
                return '_' + this.hardwareHandle + '_' + this.hardwareLock + '_' + this.hardwareColour + '_' + this.securedByDesign + '_' + this.slab + '_' + this.opening_direction + '_' + this.doorRange + '_' + this.collection + '_' + this.hardwareHandleInternal;
            },
            thumbURL(){
                return '/thumb/hardware/';
            },
        },
        watch: {
            'hardwareHandle': function (val, oldVal) {
                this.select_first_after_update = true;
                this.update_options();
            },
            'hardwareLock': function (val, oldVal) {
                this.update_options();
            },
            'hardwareColour': function (val, oldVal) {
                this.update_options();
            },
            'securedByDesign': function (val, oldVal) {
                this.select_first_after_update = true;
                this.update_options();
            },
            'slab': function (val, oldVal) {
                this.update_options();
            },
            'opening_direction': function (val, oldVal) {
                this.update_options();
            },
            'doorRange': function (val, oldVal) {
                this.update_options();
            },
            'collection': function (val, oldVal) {
                this.update_options();
            },
            'hardwareHandleInternal': function (val, oldVal) {
                this.select_first_after_update = true;
                this.update_options();
            },
        }
    }
</script>
